import { render, staticRenderFns } from "./step1.vue?vue&type=template&id=71216ab2&scoped=true"
import script from "./step1.vue?vue&type=script&lang=ts"
export * from "./step1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71216ab2",
  null
  
)

export default component.exports